<template>
  <div id="app">
    <div class="haderbox" v-if="control == 1">
      <div class="inner1440">
        <div class="flex_btw">
          <div class="fl">
            <div class="logo" @click="gothere('/')">
              <!-- 换成路径 -->
              <img
                src="@/assets/image/logo.png"
                alt="中铁建工集团第一建设公司"
                style="width: 100%"
              />
            </div>
          </div>
          <div class="navlist">
            <div
              style="
                width: 6.35vw;
                height: 9.38vw;
                position: absolute;
                right: 15vw;
                top: 3.39vw;
              "
              class="secondnav"
              v-if="navshow"
              @mouseleave="navshow = false"
            >
              <p
                style="
                  color: #06192d;
                  text-align: center;
                  margin-bottom: 0.63vw;
                  font-size: 0.73vw;
                  cursor: pointer;
                "
                class="navsecp"
                v-for="(i, j) in secondnavlist"
                :key="i.index"
                @click="turnto('产品系列', '/product', i.index)"
              >
                {{ i.label }}
              </p>
            </div>
            <div
              style="
                width: 6.35vw;
                height: 9.38vw;
                position: absolute;
                right: 29.5vw;
                top: 3.39vw;
              "
              class="secondnav"
              v-if="navshow1"
              @mouseleave="navshow1 = false"
            >
              <p
                style="
                  color: #06192d;
                  text-align: center;
                  margin-bottom: 0.63vw;
                  font-size: 0.73vw;
                  cursor: pointer;
                "
                class="navsecp"
                v-for="(i, j) in secondnavlist1"
                :key="i.index"
                @click="turnto('企业概况', '/survey', i.index)"
              >
                {{ i.label }}
              </p>
            </div>
            <div
              style="
                width: 6.35vw;
                height: 9.38vw;
                position: absolute;
                right: 24.5vw;
                top: 3.39vw;
              "
              class="secondnav"
              v-if="navshow2"
              @mouseleave="navshow2 = false"
            >
              <p
                style="
                  color: #06192d;
                  text-align: center;
                  margin-bottom: 0.63vw;
                  font-size: 0.73vw;
                  cursor: pointer;
                "
                class="navsecp"
                v-for="(i, j) in secondnavlist2"
                :key="i.index"
                @click="turnto('新闻中心', '/news', i.index)"
              >
                {{ i.label }}
              </p>
            </div>
            <div
              style="
                width: 6.35vw;
                height: 9.38vw;
                position: absolute;
                right: 10vw;
                top: 3.39vw;
              "
              class="secondnav"
              v-if="navshow3"
              @mouseleave="navshow3 = false"
            >
              <p
                style="
                  color: #06192d;
                  text-align: center;
                  margin-bottom: 0.63vw;
                  font-size: 0.73vw;
                  cursor: pointer;
                "
                class="navsecp"
                v-for="(i, j) in secondnavlist3"
                :key="i.index"
                @click="turnto('品牌文化', '/culture', i.index)"
              >
                {{ i.label }}
              </p>
            </div>
            <el-tabs
              v-model="activeName"
              @tab-click="handleClick"
              ref="navTabs"
            >
              <el-tab-pane
                :label="i.name"
                :name="i.name"
                v-for="(i, j) in navlist"
                :key="i.name"
              ></el-tab-pane>
            </el-tabs>
            <img
              style="
                width: 1.04vw;
                height: 1.04vw;
                margin-bottom: 0.3vw;
                margin-left: 1.04vw;
              "
              src="../src/assets/image/lang.png"
              alt=""
            />
            <el-select v-model="lang" placeholder="请选择">
              <el-option
                v-for="item in langoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.value === '2'"
              >
              </el-option>
            </el-select>
          </div>

          <div class="loginbtn" @click="redirectToLogin">
            <img
              src="./assets/image/login.png"
              alt=""
              style="width: 1.04vw; height: 1.04vw; margin-right: 0.16vw"
            />
            登录
          </div>
        </div>
      </div>
    </div>
    <div
      class="mheader"
      style="
        width: 100%;
        height: 40px;
        background: rgba(13, 33, 52, 1);
        padding: 7px 15px 7px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      "
      v-if="control == 0"
    >
      <img
        src="./assets/image/mlogo.png"
        alt=""
        style="width: 211px; height: 30px; margin-right: 70px"
      />
      <div style="height: 24px; display: flex">
        <img
          src="./assets/image/msearch.png"
          alt=""
          style="width: 24px; height: 24px; margin-right: 10px"
          @click="goto"
        />
        <img
          src="./assets/image/mmore.png"
          alt=""
          style="width: 24px; height: 24px"
          @click="showmnav"
        />
      </div>
      <div
        class="mnav"
        :style="{
          right: shownavs ? '0' : '-100%',
        }"
        style="
          width: 100%;
          height: 100%;
          background: #0d2134;
          position: fixed;
          right: -100%;
          top: 0;
          z-index: 999;
          transition: all 0.3s;
        "
      >
        <div class="mnavheaders">
          <img src="./assets/image/mlogo.png" alt="" class="mlogo" />
          <i
            class="el-icon-close"
            style="font-size: 24px; color: rgba(255, 255, 255, 0.8)"
            @click="closenav"
          ></i>
        </div>
        <div class="mnavcontent">
          <div
            class="manvsingle"
            v-for="(i, j) in mnavlist"
            :key="j"
            @click="mturnto(i)"
          >
            <div style="color: white; font-size: 14px">{{ i.name }}</div>
            <div>
              <i
                class="el-icon-arrow-right"
                style="color: rgba(255, 255, 255, 0.7); font-size: 24px"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; height: 4.69vw" v-if="control == 1"></div>
    <keep-alive>
      <router-view v-if="this.$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!this.$route.meta.keepAlive"></router-view>
    <div
      class="mfooter"
      v-if="control == 0"
      style="width: 100%; background: rgba(6, 25, 45, 0.9)"
    >
      <div style="width: 100%; height: 197px; padding: 0 12px">
        <div
          style="
            width: 100%;
            height: 143px;
            border-bottom: 1px solid rgba(216, 216, 216, 0.2);
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <img
            src="./assets/image/aboutus.png"
            alt=""
            style="width: 172px; height: 103px"
          />
        </div>
        <p
          style="
            text-align: center;
            color: rgba(255, 255, 255, 0.8);
            font-size: 12px;
            margin-top: 10px;
            margin-bottom: 4px;
          "
        >
          版权所有：中铁建工集团一建设公司
        </p>
        <p
          style="
            text-align: center;
            color: rgba(255, 255, 255, 0.8);
            font-size: 12px;
          "
        >
          京ICP备2023027079号-2
        </p>
      </div>
    </div>
    <div class="footer" v-if="control == 1">
      <div class="footertop">
        <div class="foottertopcontent">
          <div class="contentlist" style="display: flex">
            <img src="./assets/image/f_ic1.png" alt="" class="imgs" />
            <div class="contentsingle">
              <p class="singletitle">企业邮箱</p>
              <p class="singlecon">2042654646@qq.com</p>
            </div>
          </div>
          <div class="contentlist" style="display: flex">
            <img src="./assets/image/f_ic2.png" alt="" class="imgs" />
            <div class="contentsingle">
              <p class="singletitle">联系我们</p>
              <p class="singlecon">(010)63716576</p>
            </div>
          </div>
          <div class="contentlist" style="display: flex; min-width: 25.04vw">
            <img src="./assets/image/f_ic3.png" alt="" class="imgs" />
            <div class="contentsingle">
              <p class="singletitle">招聘中心</p>
              <p class="singlecon">
                https://mp.weixin.qq.com/s/ahQLGgglIriQykGYfVjvQA
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="footerbot">
        <div class="botleft">
          <div class="botlist" v-for="(i, j) in foorterlist" :key="i.name">
            <p style="margin-bottom: 1.46vw">{{ i.name }}</p>
            <div class="sonlist" v-for="(k, l) in i.list" :key="k">
              {{ k }}
            </div>
          </div>
        </div>
        <div class="botright">
          <div
            class="imglist"
            style="display: flex; justify-content: space-between"
          >
            <div
              class="singlelist"
              style="display: flex; justify-content: space-between"
            >
              <div
                class="icon"
                style="
                  border: 1px solid rgba(255, 255, 255, 0.5);
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  style="width: 3.66vw; height: 2.71vw"
                  src="./assets/image/icon3.png"
                  alt=""
                />
              </div>
              <p class="sign">中铁建工一公司</p>
            </div>
            <div
              class="singlelist"
              style="display: flex; justify-content: space-between"
            >
              <img class="icon" src="./assets/image/icon2.png" alt="" />
              <p class="sign">扫描关注二维码</p>
            </div>
          </div>
        </div>
      </div>
      <p
        style="
          text-align: center;
          color: rgba(255, 255, 255, 0.8);
          font-size: 0.63vw;
          padding-top: 1.04vw;
          padding-bottom: 0.21vw;
          background: rgba(6, 25, 45, 1);
          border-top: 1px solid rgba(255, 255, 255, 0.3);
        "
      >
        版权所有：中铁建工集团一建设公司
      </p>
      <p
        style="
          text-align: center;
          color: rgba(255, 255, 255, 0.8);
          font-size: 0.63vw;
          background: rgba(6, 25, 45, 1);
          padding-bottom: 1.04vw;
          cursor: pointer;
        "
        @click="turntoweb"
      >
        京ICP备2023027079号-2
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      shownavs: false,
      control: -1,
      site: [],
      quyu: {},
      cityinfo: {},
      openshow: false,
      keyword: "",
      path: "",
      index: "",
      //导航栏
      activeName: "首页",
      navlist: [
        { name: "首页", path: "/" },
        { name: "企业概况", path: "/survey" },
        { name: "新闻中心", path: "/news" },
        { name: "党的建设", path: "/build" },
        { name: "产品系列", path: "/product" },
        { name: "品牌文化", path: "/culture" },
        { name: "人才发展", path: "/joinus" },
      ],
      mnavlist: [
        { name: "首页", path: "/mindex" },
        { name: "企业概况", path: "/msurvey" },
        { name: "新闻中心", path: "/mnews" },
        { name: "党的建设", path: "/mbuild" },
        { name: "产品系列", path: "/mproduct" },
        { name: "品牌文化", path: "/mculture" },
        { name: "人才发展", path: "/mjoinus" },
      ],
      //语言选择
      lang: "1",
      langoptions: [
        { value: "1", label: "中文" },
        { value: "2", label: "ENG" },
      ],
      //底部数组
      foorterlist: [
        {
          name: "企业概况",
          list: ["企业简介", "市场布局", "企业资质", "企业荣誉"],
        },
        {
          name: "新闻中心",
          list: ["工程动态", "综合新闻"],
        },
        {
          name: "党的建设",
          list: ["党建活动"],
        },
        {
          name: "产品系列",
          list: [
            "施工总承包",
            "工程总承包(EPC)",
            "基础设施",
            "建筑工业化",
            "专业领域",
          ],
        },
        {
          name: "品牌文化",
          list: ["文化理念", "文化活动"],
        },
        {
          name: "人才发展",
          list: ["培训动态", "招聘中心"],
        },
      ],
      secondnavlist: [
        { label: "施工总承包", index: 0 },
        { label: "工程总承包", index: 1 },
        { label: "基础设施", index: 2 },
        { label: "建筑工业化", index: 3 },
        { label: "专业领域", index: 4 },
      ],
      secondnavlist1: [
        { label: "企业简介", index: 0 },
        // { label: "组织架构", index: 1 },
        { label: "市场布局", index: 2 },
        { label: "企业资质", index: 3 },
        { label: "企业荣誉", index: 4 },
      ],
      secondnavlist2: [
        { label: "综合新闻", index: 0 },
        { label: "工程动态", index: 1 },
      ],
      secondnavlist3: [
        { label: "文化理念", index: 0 },
        { label: "文化活动", index: 1 },
      ],
      secondnavlist4: [
        { label: "施工总承包", index: 0 },
        { label: "工程总承包", index: 1 },
        { label: "基础设施", index: 2 },
        { label: "建筑工业化", index: 3 },
        { label: "专业领域", index: 4 },
      ],
      navshow: false,
      navshow1: false,
      navshow2: false,
      navshow3: false,
    };
  },

  watch: {
    $route(to, from) {
      // 监听相同路由下参数变化的时候，从而实现异步刷新
      // 重新获取数据
      this.index = to.name;
    },
  },

  created: function () {
    this.$store.dispatch("getSate");

    this.index = this.$route.name;
    // this.getSite();
  },

  methods: {
    turntoweb() {
      window.open("https://beian.miit.gov.cn/#/Integrated/recordQuery");
    },
    goto() {
      this.$router.push({
        path: "/msearch",
      });
    },
    mturnto(e) {
      this.$router.push({
        path: e.path,
      });
      this.shownavs = false;
    },
    closenav() {
      this.shownavs = false;
    },
    showmnav() {
      this.shownavs = true;
    },
    turnto(n, p, e) {
      this.activeName = n;
      this.$router.push({
        path: p,
        query: { index: e },
      });
    },
    redirectToLogin() {
      // 使用window.location.href进行URL跳转
      window.location.href = "https://webmanage.crcegjgygs.com/#/login";
    },
    search(e) {
      this.gothere("/search?keyword=" + e);
    },
    choseCity(id) {
      this.openshow = false;
      this.$store.commit("setCity", id);
      this.gothere("/city?id=" + id);
    },
    getSite() {
      var that = this;
      this.rq.requests
        .post("/api/Hall/getSite", {})
        .then((res) => {
          that.$store.commit("setSite", res.data);
          that.site = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCity() {
      var that = this;
      this.rq.requests
        .post("/api/Hall/getCity", {})
        .then((res) => {
          that.cityinfo = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getQuyu() {
      var that = this;
      this.rq.requests
        .post("/api/Hall/getQuyu", {})
        .then((res) => {
          that.$store.commit("setInfo", res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleClick(e) {
      for (let i in this.navlist) {
        if (i == e.index) {
          this.$router.push({
            path: this.navlist[i].path,
          });
        }
      }
    },
    gothere(url) {
      this.$router.push({
        path: url,
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.navTabs.$refs.nav.$nextTick(() => {
        let target = document.getElementsByClassName("el-tabs__item");
        let that = this;
        for (let i = 0; i < target.length; i++) {
          target[i].addEventListener("mouseover", () => {
            if (i == 4) {
              this.navshow = true;
              this.navshow1 = false;
              this.navshow2 = false;
              this.navshow3 = false;
            } else if (i == 1) {
              this.navshow = false;
              this.navshow1 = true;
              this.navshow2 = false;
              this.navshow3 = false;
            } else if (i == 2) {
              this.navshow = false;
              this.navshow1 = false;
              this.navshow2 = true;
              this.navshow3 = false;
            } else if (i == 5) {
              this.navshow = false;
              this.navshow1 = false;
              this.navshow2 = false;
              this.navshow3 = true;
            } else {
              this.navshow = false;
              this.navshow1 = false;
              this.navshow2 = false;
              this.navshow3 = false;
            }
          });
          // target[i].addEventListener("mouseleave", () => {
          //   this.navshow = false;
          // });
        }
      });
    });
    if (this.$route.meta.requiresMobile) {
      this.control = 0;
    } else {
      this.control = 1;
    }
  },
};
</script>
<style lang="less">
@import url("./assets/css/app.css");
#app::-webkit-scrollbar {
  display: none !important; /* Chrome Safari */
}
.mnav {
  .mnavcontent {
    .manvsingle {
      width: 100%;
      height: 43px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid rgba(88, 92, 110, 1);
      padding-right: 15px;
    }
    padding: 0 15px;
    width: 100%;
    padding-right: 0;
  }
  .mnavheaders {
    .mlogo {
      width: 211px;
      height: 30px;
    }
    width: 100%;
    height: 40px;
    padding: 0 15px 0 10px;
    border-bottom: 1px solid rgba(88, 92, 110, 1);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.loginbtn {
  width: 3.65vw;
  height: 1.46vw;
  border: 1px solid #1961ac;
  margin-bottom: 0.52vw;
  border-radius: 0.21vw;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.73vw;
  color: #1961ac;
}

.navlist {
  .secondnav {
    .navsecp:hover {
      color: #1961ac !important;
    }
    background: url("./assets/image/secondnavlist.png") no-repeat;
    background-position: 0 0;
    background-size: 100% 100%;
    padding: 1.04vw 1vw 0.63vw 1vw;
    text-align: center;
  }
  .el-tabs__nav-wrap::after {
    height: 0px !important;
  }
  .el-tabs__item.is-active {
    color: #1968bc !important;
    font-weight: 550 !important;
  }
  .el-tabs__active-bar {
    background-color: #1968bc !important;
  }
  .el-tabs__item {
    padding: 0 0.78vw;
    font-size: 0.83vw !important;
    color: #1a1a1a;
    font-weight: normal;
  }
  .el-tabs__header {
    margin: 0 !important;
    margin-bottom: 0.52vw !important;
  }
  display: flex;
  align-items: center;
  margin-left: 4.5vw;
  position: relative;
}
.el-tabs__item:hover {
  color: #1a1a1a !important;
  cursor: pointer;
  opacity: 1;
}
.el-select {
  width: 4.27vw;
  margin-bottom: 0.4vw;
}
.el-input__inner {
  border: 0px !important;
  font-size: 0.83vw !important;
  padding-left: 0.31vw !important;
  padding-right: 0.52vw !important;
}
.el-input__suffix {
  right: 0.52vw;
}
.el-select .el-input .el-select__caret {
  color: #1a1a1a !important;
}
</style>
